import NumberSystems from "../NumberSystems";
import {
    decimalToBinary,
    decimalToHexadecimal,
    decimalToOctal//,
    //octalToDecimal
} from "../logic/Conversion";
import {getRandomIntegerWithRange/*, getRandomNumberWithRange*/} from "../Random";
import BinaryAddition from "../logic/BinaryAddition";

export default class ExerciseGenerator{
    constructor(mode) {
        this.mode = mode;
    }
    getRandomBitCount = () => {
        const bitCount = this.mode.getBitCount();
        return bitCount[getRandomIntegerWithRange(0, bitCount.length)];
    };

    convertByNumberSystem =(value, numberSystem)=>{
        switch(numberSystem){
            case NumberSystems.BINARY:
                return String(decimalToBinary(value));
            case NumberSystems.DECIMAL:
                return String(value);
            case NumberSystems.OCTAL:
                return String(decimalToOctal(value));
            case NumberSystems.HEXADECIMAL:
                return String(decimalToHexadecimal(value));
            default:
                throw new Error("Invalid number system");
        }
    };

    getRandomFloatingPointValue = (integerRange, decimalsMinLength) => {
        let integers = getRandomIntegerWithRange(integerRange[0], integerRange[1]);
        let decimals;
        //Copied from android app, prevents too long tasks
        const presetValues = [0.5, 0.25, 0.125, 0.0625, 0.03125, 0.015625];
        //Result will always be divisible by 5 which prevents too long tasks
        decimals = 0.0;
        for(let i = 0; i<presetValues.length; i++){
            if(this.getRandomBoolean()){
                const newValue = decimals + presetValues[i];
                //Ensure the number of decimal places (length +2 because the value will be 0.x)
                if(String(newValue).length <= decimalsMinLength+2){
                    decimals = newValue;
                }
            }
        }

        //If the generatedValue is too small, try again
        if(String(decimals).length < decimalsMinLength+2){
            return this.getRandomFloatingPointValue(integerRange, decimalsMinLength);
        }
        return  Number(integers+decimals);
    };

    getRandomBoolean = () => {
        return Math.random() >= 0.5;
    };
/* These functions seem not to be used, just keep it for future usage

      removeCharacterAtIndex = (value, position) => {
        const part1 = value.substring(0, position);
        const part2 = value.substring(position + 1, value.length);
        return (part1 + part2);
    };

    insertCharacterAtIndex = (value, char, position) => {
        const part1 = value.substring(0, position);
        const part2 = value.substring(position+1, value.length);
        return part1+char+part2;
    };

    reverseString = (string) => {
        return string.split("").reverse().join("");
    };

    deleteUpfrontZeroes = (toConvert) => {
        let tmp = "";
        tmp += (toConvert);
        if (toConvert !== "") {
            tmp = this.reverseString(tmp);
            while (tmp.charAt(tmp.length - 1) == '0' && tmp.length!=1){
                tmp = tmp.substring(0, tmp.length-2);
            }
            //tmp.deleteCharAt(tmp.length - 1);
            tmp = this.reverseString(tmp)
        }
        return tmp.toString();
    };
*/
    /**
     * https://stackoverflow.com/questions/40353000/javascript-add-two-binary-numbers-returning-binary
     * https://stackoverflow.com/questions/40353000/javascript-add-two-binary-numbers-returning-binary/46477181#46477181
     */
    binaryAddition = BinaryAddition;

    signBit = (value, bitCount) => {
        const binaryValue = decimalToBinary(value >= 0 ? value : -value, bitCount);
        if(value >= 0){
            return binaryValue;
        }else{
            return "1" + binaryValue.substring(1,bitCount);
        }
    }

    oneComplement = (value, bitCount) => {
        //Convert a positive number, the signed bit will be added during flipping
        const binaryValue = decimalToBinary(value < 0 ? value * -1 : value, bitCount);
        if(Number(value>=0)){
            return binaryValue;
        }

        let flippedValue = "";
        for(let i=0; i<binaryValue.length; i++) {
            if (binaryValue.charAt(i) === '1') {
                flippedValue = flippedValue+"0";
            } else {
                flippedValue = flippedValue+"1";
            }
        }

        return flippedValue;
    };

    twoComplement = (value, bitCount) => {
        const complement = this.oneComplement(value, bitCount);
        if(value < 0){
            return this.binaryAddition(complement, "1");
        }else{
            return complement;
        }
    }
}